
import WebFont from 'webfontloader'

const options = {"google":{"families":["Noto+Sans+JP:400,700"]}}

WebFont.load(options)
